import { api } from "./useApi";

export const categoriasApi = () => ({
  // Aparentemente criarCategoria nunca é chamado, transformando pasta/criar em codigo morto tb, deixarei comentado por um tempo só pra
  // criarCategoria: async (descricao: string, id_pasta: number) => {
  //   const pasta = {
  //     descricao: descricao,
  //     id_pasta: id_pasta,
  //   };
  //   const response = await api.post("pasta/criar", pasta);
  //   return response.data;
  // },

  verificarNomeCategoria: async (descricao: string, id: number, id_pasta_pai: number = 0) => {
    const response = await api.post("pasta/verificar_nome", { descricao, id, id_pasta_pai });
    return response.data;
  },
  salvarCategoria: async (pasta: {
    id?: number;
    descricao: string;
    imagem?: string;
    id_pasta_pai?: number;
    reativar_produtos?: boolean;
  }) => {
    const response = await api.post("pasta/salvar", { pasta });
    return response.data;
  },
  removerCategoria: async (id_pasta: number) => {
    const response = await api.post("pasta/remover", { id_pasta });
    return response.data;
  },
});
